(() => {
  const canvases = document.querySelectorAll('[data-orbit-canvas]');
  if (!canvases.length) return;
  const sections = document.querySelectorAll('.mn-routine-orbit-v1');

  const setOrbitPositions = (canvas) => {
    const ring = canvas.querySelector('[data-orbit-ring]');
    const nodes = ring ? ring.querySelectorAll('[data-orbit-node]') : [];
    if (!nodes.length) return;

    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const radius = Number(canvas.dataset[mobile ? 'radiusMobile' : 'radiusDesktop']) || 140;
    const count = nodes.length;
    const step = (Math.PI * 2) / count;
    const startAngle = -Math.PI / 2;

    nodes.forEach((node, index) => {
      const angle = startAngle + step * index;
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      node.style.setProperty('--orbit-x', `${x.toFixed(2)}px`);
      node.style.setProperty('--orbit-y', `${y.toFixed(2)}px`);
    });
  };

  const wireNodeImageSwitching = (canvas) => {
    const centerImage = canvas.querySelector('[data-orbit-center-image]');
    const nodes = canvas.querySelectorAll('[data-orbit-node]');
    if (!centerImage || !nodes.length) return;

    const setActiveNode = (node) => {
      nodes.forEach((item) => item.classList.toggle('is-active', item === node));
    };

    nodes.forEach((node) => {
      node.addEventListener('click', () => {
        const imageUrl = node.dataset.nodeImage;
        if (!imageUrl) return;
        centerImage.src = imageUrl;
        centerImage.alt = node.dataset.nodeAlt || centerImage.alt || '';
        setActiveNode(node);
      });
    });

    // If a block has an image, use the first one as the initial active state.
    const firstWithImage = Array.from(nodes).find((node) => !!node.dataset.nodeImage);
    if (firstWithImage) {
      firstWithImage.click();
    }
  };

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const updateScrollMotion = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const progressRaw = (vh - rect.top) / (vh + rect.height);
      const progress = clamp(progressRaw, 0, 1);

      // Premium "forward/back" spring feeling while scrolling through section.
      const wave = Math.sin(progress * Math.PI * 3.2);
      const envelope = Math.sin(progress * Math.PI); // fade in/out at edges
      const pop = wave * envelope;
      const shiftY = pop * -10;
      const tilt = pop * 1.6;

      section.style.setProperty('--orbit-pop', pop.toFixed(4));
      section.style.setProperty('--orbit-shift-y', `${shiftY.toFixed(2)}px`);
      section.style.setProperty('--orbit-tilt', `${tilt.toFixed(2)}deg`);
    });
  };

  const refreshAll = () => {
    canvases.forEach(setOrbitPositions);
    canvases.forEach(wireNodeImageSwitching);
    updateScrollMotion();
  };

  refreshAll();
  window.addEventListener('resize', refreshAll);
  window.addEventListener('scroll', updateScrollMotion, { passive: true });
  document.addEventListener('shopify:section:load', refreshAll);
  document.addEventListener('shopify:section:select', refreshAll);
})();
